var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounToggles630837Off(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 57.044998,
    width: 100,
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 57.044998",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.7182131,0,0,1.7182131,-35.910653,-24.742268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 37.5,47.6 h 25 c 9.1,0 16.6,-7.5 16.6,-16.6 v 0 c 0,-9.1 -7.5,-16.6 -16.6,-16.6 h -25 c -9.1,0 -16.6,7.5 -16.6,16.6 v 0 c 0,9.2 7.5,16.6 16.6,16.6 z m 0,-28.7 c 6.7,0 12.1,5.4 12.1,12.1 0,6.7 -5.4,12.1 -12.1,12.1 C 30.8,43.1 25.4,37.7 25.4,31 25.3,24.4 30.8,18.9 37.5,18.9 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounToggles630837Off);
export default __webpack_public_path__ + "static/media/noun_toggles_630837_off.f5272cb5.svg";
export { ForwardRef as ReactComponent };